var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodInStoolFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 462,
    viewBox: "0 0 462 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4585:7422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.16 462C358.649 462 462 358.649 462 231.16C462 103.671 358.649 0.320007 231.16 0.320007C103.671 0.320007 0.320007 103.671 0.320007 231.16C0.320007 358.649 103.671 462 231.16 462Z",
    fill: "#D0CFE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.942 282.753C313.942 284.3 313.942 285.889 313.844 287.534C313.746 289.179 313.717 290.698 313.619 292.329C312.621 311.407 309.316 330.294 303.776 348.577H179.412V282.753H313.942Z",
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.277 255.262C333.344 259.08 332.531 262.862 330.901 266.315C326.542 275.596 317.641 280.827 313.942 282.753H185.065V253.153H333.151C333.217 253.79 333.259 254.493 333.277 255.262Z",
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.942 282.753C313.942 284.3 313.942 285.903 313.844 287.534H185.065V282.753H313.942Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.302 282.753C195.091 289.714 194.683 296.913 194.107 304.31C192.855 320.284 190.859 335.106 188.482 348.633H179.426V282.753H185.051V253.153H195.302C195.611 262.49 195.626 272.39 195.302 282.753Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.593 265.977C189.537 271.602 189.429 277.194 189.27 282.753C188.581 306.11 187.104 328.103 185.051 348.633H133.022V135.427H159.248C173.492 135.427 185.023 147.646 185.023 162.735C187.146 184.179 188.693 207.353 189.242 232.088C189.242 234.591 189.368 237.094 189.396 239.625C189.631 248.231 189.696 257.015 189.593 265.977Z",
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3 239.625H196.188C192.522 239.625 189.551 242.597 189.551 246.262V246.516C189.551 250.181 192.522 253.153 196.188 253.153H328.3C331.965 253.153 334.937 250.181 334.937 246.516V246.262C334.937 242.597 331.965 239.625 328.3 239.625Z",
    fill: "#5A52C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.277 255.262H194.065V253.153H333.123C333.207 253.79 333.259 254.493 333.277 255.262Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.165 186.359C285.987 197.608 274.963 209.041 260.367 210.025C243.886 211.122 230.246 198.354 226.885 185.81C223.651 173.703 230.274 162.946 240.413 146.437C245.489 138.185 251.459 130.517 258.215 123.573C265.237 130.33 271.379 137.946 276.495 146.24C285.565 161.174 292.92 173.141 289.165 186.359Z",
    fill: "#F27468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.894 175.63C283.794 175.728 284.905 182.998 281.881 189.79C279.969 194.135 275.947 199.225 273.444 198.494C273.044 198.352 272.686 198.111 272.404 197.794C272.121 197.477 271.923 197.094 271.827 196.68C271.307 194.388 274.724 192.462 277.297 189.649C282.866 183.336 281.966 175.517 282.894 175.63Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4585:7422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 461.68,
    height: 461.68,
    fill: "#5A52C3",
    transform: "translate(0.320007 0.320007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodInStoolFemale);
export default __webpack_public_path__ + "static/media/bloodInStool_female.8e8efcd766ed09b2f7b37becd759a2dd.svg";
export { ForwardRef as ReactComponent };